import React from "react";
import { ReportsContainer } from "../../../containers";
const Reports = (props) => {
  return <ReportsContainer {...props} />;
};

export default Reports;
